// extracted by mini-css-extract-plugin
export default {"iconWithText":"IconWithText_iconWithText__PqZYI","text":"IconWithText_text__7-aEz"};